export enum WindowsServiceState {
    ServiceRunning = 'ServiceRunning',
    ServiceStopped = 'ServiceStopped',
    ServiceStopPending = 'ServiceStopPending',
    ServiceStartPending = 'ServiceStartPending',
}
